




























































import Vue, { PropType } from 'vue'
import FormSubmission from '@/types/FormSubmission.interface'
export default Vue.extend({
    props: {
        // The color of the component
        color: {
            type: String,
            required: false,
            default: 'primary'
        },
        // The form submission
        submission: {
            type: Object as PropType<FormSubmission>,
            required: true
        }
    },
    computed: {
        navigateEnabled(): boolean {
            return this.submission?.person?.id
        },
        messageEnabled(): boolean {
            return this.submission?.person?.primary_channel_id
        },
        operator(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            return window.getProps(role, ['name']) === 'Operator'
        },
        submissionDataCount(): boolean {
            return this.submission?.submission?.length
        }
    },
    methods: {
        popNotFoundHelp(): void {
            this.$store.dispatch('dialogOpen', {
                type: 'MESSAGE',
                title: 'Help',
                text: 'Prior to release v1.3.2, form submission data were not collected.',
                icon: 'mdi-help-circle',
                color: 'primary'
            })
        }
    }
})
